import React from "react";
import { FaTaxi, FaClock, FaPlaneArrival, FaRoute, FaMobileAlt, FaMapMarkedAlt, FaBriefcase, FaHome, FaCar, FaUsers , FaPlaneDeparture } from "react-icons/fa";

const services = [

  {
    title: "Pune Cab Booking Service",
    icon: <FaTaxi />,
    desc: "Book reliable and comfortable cabs in Pune with SRS Cab Service. Enjoy safe rides with professional drivers at affordable prices.",
  },
  {
    title: "Online Cab Booking Service",
    icon: <FaMobileAlt />,
    desc: "Easily book your cab online anytime, anywhere. Our simple and fast booking system ensures a hassle-free experience.",
  },
  {
    title: "24/7 Available Cab Service",
    icon: <FaClock />,
    desc: "We are available round the clock to serve you. Whether it's early morning or late night, SRS Cab is always ready.",
  },
  {
    title: "One Way Cab Service",
    icon: <FaRoute />,
    desc: "Travel one-way without paying for return fare. Perfect for outstation trips with cost-effective pricing.",
  },
  {
    title: "Airport Cab Service",
    icon: <FaPlaneDeparture />,
    desc: "On-time airport pickup and drop services with flight tracking for a stress-free travel experience.",
  },
  {
    title: "Outstation Cab Service",
    icon: <FaMapMarkedAlt />,
    desc: "Plan your outstation trips with ease. Enjoy long-distance travel with comfortable cars and experienced drivers.",
  },
{
  title: "Corporate Events Cab Service",
  icon: <FaUsers />,
  desc: "Reliable cab services for corporate events, meetings, and conferences. Ensure smooth and timely transportation for your team and guests.",
},
{
  title: "One-Way & Round Trip Cabs",
  icon: <FaRoute />,
  desc: "Choose between one-way or round trip cab services based on your travel needs. Flexible options at affordable pricing.",
},
{
  title: "Mumbai Airport Cab Service",
  icon: <FaPlaneArrival />,
  desc: "Get timely airport pickup and drop services in Mumbai with real-time flight tracking for a smooth travel experience.",
},
{
  title: "Corporate Cab Services in Mumbai",
  icon: <FaBriefcase />,
  desc: "Professional cab services tailored for corporate clients. Ensure timely office commutes and business travel solutions.",
},
{
  title: "Door-to-Door Pickup & Drop Service",
  icon: <FaHome />,
  desc: "Enjoy hassle-free travel with our convenient door-to-door pickup and drop service, ensuring comfort and safety.",
},
{
  title: "Marriage Event Cab Service",
  icon: <FaCar />,
  desc: "Make your special day stress-free with our dedicated cab services for wedding events, ensuring smooth transportation for guests.",
}

];

const Services = () => {
  return (

<>


    <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Services</h2>
          </div>
        </div>
      </div>
    </div>

    <section className="sectionn services bg-light-primary">
      <div className="container">
        
        {/* Heading */}
        <div className="section-heading text-center" data-aos="fade-down">
          <h2>Our Cab Services</h2>
          <p>
            SRS Cab Service offers reliable, affordable, and safe transportation solutions tailored to your travel needs.
          </p>
        </div>

        {/* Services Grid */}
        <div className="row">
          {services.map((service, index) => (
            <div
              className="col-lg-4 col-md-6 col-12 d-flex"
              key={index}
              data-aos="fade-up"
            >
              <div className="card flex-fill text-center p-4 service-card">
                
                {/* Icon */}
                <div className="service-ion mb-3">
                  <span className="icon-style">
                    {service.icon}
                  </span>
                </div>

                {/* Content */}
                <h4>{service.title}</h4>
                <p>{service.desc}</p>

              </div>
            </div>
          ))}
        </div>

      </div>

      {/* Inline CSS */}
      <style jsx>{`
        .service-card {
          border-radius: 15px;
          transition: 0.3s;
        }
        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }
        .icon-style {
          font-size: 70px; /* Bigger icon size */
          color: #FFA803;
        }
      `}</style>
    </section>
</>
  );
};

export default Services;